import React, { useEffect } from 'react';
import type { ComponentType, ReactNode } from 'react';

import { withFlags } from '@confluence/flags/entry-points/withFlags';
import type { FlagsStateContainer } from '@confluence/flags/entry-points/FlagsStateContainer';
import { ErrorDisplay } from '@confluence/error-boundary/entry-points/ErrorDisplay';
import type { ApolloErrorInterop } from '@confluence/apollo-relay-interop/entry-points/ApolloErrorInterop';

type ActionErrorFlagProps = {
	title: ReactNode;
	description: ReactNode;
	error: ApolloErrorInterop;
};

export const ActionErrorFlag: ComponentType<ActionErrorFlagProps> = withFlags(
	({ flags, title, description, error }: ActionErrorFlagProps & { flags: FlagsStateContainer }) => {
		useEffect(() => {
			void flags.showErrorFlag({
				id: 'action-button-error',
				title,
				description,
			});
		}, [title, description, flags]);

		return <ErrorDisplay error={error} />;
	},
);
